export default __webpack_public_path__ + "static/media/up-range.4fc2b2ae.svg";